import { memo } from 'react';
import { motion } from 'framer-motion';
import { Box } from '@chakra-ui/react';

import { faqItemToggleVariants } from 'constants/faq';
import { DEFAULT_TRANSITION } from 'constants/global';

const FaqItemToggle = () => (
  <Box
    as={motion.svg}
    boxSize="18px"
    viewBox="0 0 18 18"
    objectFit="cover"
    stroke="ourBlack"
    transition={DEFAULT_TRANSITION}
  >
    {faqItemToggleVariants.map((val, i) => (
      <Path key={i} {...val} />
    ))}
  </Box>
);

const Path = props => (
  <Box as={motion.path} fill="transparent" strokeWidth="1.6" strokeLinecap="round" {...props} />
);

export default memo(FaqItemToggle);
